export default function negateNgModelDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      $ngModel.$formatters.push((value) => !value);
      $ngModel.$parsers.push((value) => !value);
    },
  };
}
